// extracted by mini-css-extract-plugin
module.exports = {"pillWrapper":"Pill_pillWrapper___VyGg","icon":"Pill_icon__liDAK"};